export const getAcronymFromName = (name: string): string => {
  return name.substring(0, 2).toUpperCase();
};
